import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import {
  NOJOOM_STATUS_COLORS,
  SELECTED_LANG,
} from '../../services/common/Constants';
import { EndPointUserDetails } from '../../services/common/endpoints';
import {
  GetHomeGreetText,
  getItemOfSessionStorage,
  isContainAlphabet,
} from '../../services/common/utils';
import Loadingcomponent from '../loader/loadingcomponent';

const NojoomUserInfo = () => {
  const { t } = useTranslation();
  const {
    nojoomData: { nojoomDashboardMsisdnData },
  } = useSelector((state) => state);

  const userdetailsApi = useQuery(
    ['user-details', EndPointUserDetails.url, EndPointUserDetails.data, {}],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
    }
  );

  const nicnameText = () => {
    if (getItemOfSessionStorage(SELECTED_LANG) === 'en') {
      return userDetails?.nickname !== null && userDetails?.nickname;
    } else {
      if (isContainAlphabet(userDetails?.nickname)) {
        return userDetails?.nickname !== null && userDetails?.nickname;
      } else {
        return userDetails?.nickname !== null && userDetails?.nickname;
      }
    }
  };

  let userDetails = userdetailsApi?.data?.data?.response || {};

  const isBirthDay =
    //eslint-disable-next-line
    (userDetails?.dob?.split('/')[0] == new Date().getDate() &&
      //eslint-disable-next-line
      userDetails?.dob?.split('/')[1] == new Date().getMonth() + 1) ||
    false;

  if (userdetailsApi?.isLoading) {
    return (
      <div style={{backgroundColor: 'white', height: '110px'}}>
        <Loadingcomponent />
      </div>
    )
  }

  return (
    // <div
    //   className="background_grey div-height"
    //   style={{ backgroundColor: themeColor }}
    // >
    //   <div className="app_alerts_wrap no_alerts mt-4 pse_sm">
    //     <div className="profile_info">
    //       <div className="profile_info_img">
    //         <img
    //           src={
    //             userDetails?.profilepic ||
    //             process.env.PUBLIC_URL + '/assets/images/user.png'
    //           }
    //           alt=""
    //           title=""
    //         />
    //       </div>
    //       <div
    //         className={
    //           isContainAlphabet(userDetails?.nickname)
    //             ? 'profile_info_desc'
    //             : 'profile_info_desc_rtl'
    //         }
    //       >
    //         <h3 className="message section_title mb-0 text-ellipsis">
    //           {isBirthDay ? `${t('hb')},` : GetHomeGreetText(t)}
    //         </h3>
    //         <h1 className="profile_name text-ellipsis">{nicnameText()}</h1>

    //         {nojoomDashboardMsisdnData?.TierLevel && (
    //           <div
    //             className="mt-2 nojoom_header_status d-flex align-items-center"
    //             style={{
    //               backgroundColor:
    //                 NOJOOM_STATUS_COLORS[nojoomDashboardMsisdnData?.TierLevel?.toUpperCase()],
    //             }}
    //           >
    //             <img
    //               src={
    //                 process.env.PUBLIC_URL +
    //                 '/assets/images/nojoom_star_selected_red.svg'
    //               }
    //               alt=""
    //               title=""
    //             />
    //             <label className="ms-1">{nojoomDashboardMsisdnData?.TierLevel?.toUpperCase()}</label>
    //           </div>
    //         )}
    //       </div>
    //     </div>
    //   </div>
    // </div>

    <div className="fullbg_banner_white">
      {/* <div class="full-banner-img">
        <div class="bg-opect"></div>
        <img
          src={process.env.PUBLIC_URL + '/assets/images/esim-home-banner.jpg'}
          alt=""
          title=""
          class="ms-2 pointer"
        />
      </div> */}

      <div className="no_alerts mt-3 mb-3 pse_sm">
        <div className="profile_info">
          <div className="profile_info_img">
            <img
              src={
                userDetails?.profilepic ||
                process.env.PUBLIC_URL + '/assets/images/sprint16/ooredoo-sm-logo.svg'
              }
              alt=""
              title=""
            />
          </div>
          <div
            className={
              isContainAlphabet(userDetails?.nickname)
                ? 'profile_info_desc'
                : 'profile_info_desc_rtl'
            }
          >
            <h3 className="message section_title mb-0 text-ellipsis">
              {isBirthDay ? `${t('hb')},` : GetHomeGreetText(t)}
            </h3>
            <h1 className="profile_name text-ellipsis">{nicnameText()}</h1>

            {nojoomDashboardMsisdnData?.TierLevel && (
              <div
                className="mt-2 nojoom_header_status d-flex align-items-center"
                style={{
                  backgroundColor:
                    NOJOOM_STATUS_COLORS[
                      nojoomDashboardMsisdnData?.TierLevel?.toUpperCase()
                    ],
                }}
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    '/assets/images/nojoom_star_selected_red.svg'
                  }
                  alt=""
                  title=""
                />
                <label className="ms-1">
                  {nojoomDashboardMsisdnData?.TierLevel?.toUpperCase()}
                </label>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NojoomUserInfo;
